import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";

/**
 * Manual "Sync now": asks the API to fan out an immediate inbox sync for the
 * brand (instead of waiting for the 10-minute poll). The sync runs async on the
 * worker, so we refetch the inbox lists shortly after to surface fresh rows.
 */
export function useSyncInboxNow(brandId: string) {
  const qc = useQueryClient();

  function refresh() {
    qc.invalidateQueries({ queryKey: ["inbox-conversations", brandId] });
    qc.invalidateQueries({ queryKey: ["inbox-comments", brandId] });
    qc.invalidateQueries({ queryKey: ["inbox-unread", brandId] });
  }

  return useMutation<{ queued: boolean }, Error, void>({
    mutationFn: () =>
      apiFetch<{ queued: boolean }>(`/brands/${brandId}/inbox/sync`, {
        method: "POST",
      }),
    onSuccess: () => {
      // The jobs are processed within a few seconds; refetch now and again
      // shortly after so newly-synced conversations/comments appear.
      refresh();
      setTimeout(refresh, 4000);
    },
  });
}
